module.exports = __webpack_public_path__ + "img/SI.358168b6.png";